import { sql } from "drizzle-orm";

import type { WsFile } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { file } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

export async function bulkUpsertFile(records: WsFile[], deferEmit = false) {
  if (records.length === 0) return;
  const deduped = deduplicateByKeyValue(records, (item) => item.id);
  await bulkInsert(file, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [file.id],
      set: {
        contentId: sql`"excluded"."contentId"`,
        mimeType: sql`"excluded"."mimeType"`,
        name: sql`"excluded"."name"`,
        url: sql`"excluded"."url"`,
      },
    },
  });
  if (!deferEmit) {
    emitTableUpdates(["file"]);
  }
}
